import React from "react";
import { Form } from "rsuite";
import styled, { css } from "styled-components";


const StyledFormControl = styled(Form.Group)`
    && {
        display: flex;

        ${props => props.horizontal && css`
            flex-direction: row;
            align-items: center;
            gap: ${props.gap ?? 16}px;
        `}

        ${props => props.vertical && css`
            flex-direction: column;
            justify-content: center;
            gap: ${props.gap ?? 16}px;
        `}
    }

    &&.rs-form-group:not(:last-child) {
        margin-bottom: 0;
    }

   
    ${props => props.fullWidth && css`
        && .rs-form-control.rs-form-control-wrapper, .rs-form-control.rs-form-control-wrapper .rs-input,
        .rs-form-control.rs-form-control-wrapper .rs-picker {
            width: 100% !important;
        }
    `}


`;

const FormGroup = ({ children, gap, horizontal, vertical, fullWidth, className, ...props }: { children: React.ReactNode; gap?: number; fullWidth?: boolean; className?: string; horizontal?: boolean; vertical?: boolean }) => {
    return (
        <StyledFormControl
            gap={gap}
            fullWidth={fullWidth}
            className={className}
            horizontal={horizontal}
            vertical={vertical}
            {...props}
        >
            {children}
        </StyledFormControl>
    );
};

export default FormGroup;
